import { evalSummary } from "common/components/portable-renderers";
import { ActionSource, LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { ListItemFlags } from "generator/array-screens/list-item-flags";
import { useForce } from "hooks/use-force";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useForceValueProducers } from "hooks/use-value-producers";

import type { MenuItem } from "../lib/menu-item";
import ListItem from "../ui/smart/list-item/list-item";

export const PhoneNumberMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[numberValue, captionValue, onPhoneCall, onTextMessage]] = useForceValueProducers(
        getValueProducers,
        force,
        ctx
    );
    const { onClick: onClickSMS, targetURL: smsURL } = useOnClickFromAction(
        onTextMessage,
        ActionSource.TextMessage,
        ctx,
        env
    );
    const { onClick: onClickPhone, targetURL: phoneURL } = useOnClickFromAction(
        onPhoneCall,
        ActionSource.Phone,
        ctx,
        env
    );
    if (numberValue === undefined) return null;

    const { title, subtitle } = evalSummary(numberValue, captionValue, undefined, force);
    // FIXME: We need two handlers in `ListItem`: one for phone, one for SMS
    const menuItems: MenuItem[] = [];

    if (onClickSMS !== undefined) {
        menuItems.push({
            title: "sms",
            icon: "message-circle",
            href: smsURL,
            onClick: onClickSMS,
        });
    }

    if (onClickPhone !== undefined) {
        menuItems.push({
            title: "phone",
            icon: "phone",
            href: phoneURL,
            onClick: onClickPhone,
        });
    }

    return (
        <ListItem
            title={numberValue === LOADING ? LOADING : title}
            subtitle={captionValue === LOADING ? LOADING : subtitle}
            menuItems={menuItems}
            onClick={onClickPhone ?? onClickSMS}
            targetUrl={phoneURL ?? smsURL}
            appEnvironment={env.appEnvironment}
            flags={ListItemFlags.InvertTitleAndSubtitle}
        />
    );
};
